import {
  Link,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

type Props = {
  name: string;
  link: string;
  content: string;
};

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 16,
  lineHeight: "22px !important",
}));

const AnnexureTabs = ({ annexures }: any) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {annexures.map((a: Props, i: number) => (
            <TableRow key={i}>
              <TableCell sx={{ color: "primary.main" }}>{a.name}</TableCell>
              <TableCell sx={{ color: "primary.main" }}>:</TableCell>
              <TableCell>
                <Link href={a.link} target="_blank">
                  {a.content}
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AnnexureTabs;
